import { useContext, useMemo } from "react";

import SponsorsBoard from "../components/Sponsors/SponsorsBoard";
import {
  useGetSponsors,
  useGetSponsorLevels,
  useGetSponsorReps,
} from "../api/sponsors";
import { AuthContext } from "../services/context";
import { getCurrentWorkspace } from "../services/userConfig";
import { useSetActionButtons } from "../services/ActionButtonsContext";
import { IconListNumbers, IconPlus } from "@tabler/icons-react";
import { useGetGiveawayByEventId } from "../api/giveaways";

function Sponsors() {
  const actions = useMemo(
    () => [
      {
        label: "Levels",
        icon: <IconListNumbers />,
        navigate: "./sponsors/levels",
      },
      {
        label: "Create",
        icon: <IconPlus />,
        navigate: "./sponsors/create",
      },
    ],
    []
  );

  useSetActionButtons(actions);

  const { user } = useContext(AuthContext);
  const { eventId } = getCurrentWorkspace(user);

  const { data, isPending: isLoadingSponsors } = useGetSponsors({
    eventId,
  });

  const { data: levels, isPending: isLoadingLevels } = useGetSponsorLevels({
    eventId,
  });

  const { data: sponsorReps, isPending: isLoadingReps } = useGetSponsorReps({
    eventId,
  });

  const { data: giveaway } = useGetGiveawayByEventId(eventId);

  const sponsorsInGiveaway = useMemo(
    () => new Set((giveaway?.sponsors || []).map((s) => s.id)),
    [giveaway]
  );

  const sponsors = useMemo(
    () =>
      (data?.data || []).map((sponsor) => ({
        ...sponsor,
        isInGiveaway: sponsorsInGiveaway.has(sponsor.id),
      })),
    [data, sponsorsInGiveaway]
  );

  return (
    <SponsorsBoard
      sponsors={sponsors}
      levels={levels}
      sponsorReps={sponsorReps}
      eventId={eventId}
      isLoading={isLoadingSponsors || isLoadingLevels || isLoadingReps}
    />
  );
}

export default Sponsors;
